module.exports = __webpack_public_path__ + "img/weavr_loader.ff0af09f.svg";